import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useDeleteChallenge = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (challengeId) => {
      const result = await restClient({
        url: `${prefix}/challenge-definitions/${challengeId}`,
        method: 'DELETE'
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch challenges list after successful delete
      queryClient.invalidateQueries({ queryKey: ['resultsChallenges'] });
    },
    onError: (error) => {
      console.error('Error deleting challenge:', error);
    }
  });
};
